
import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CFormInput,
  CButton
} from '@coreui/react-pro'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

// helper
import { useResponsive } from 'src/helpers/get-responsive'

const FormTextInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  placeholder,
  value,
  handleTextInput,
  feedbackInvalid,
  invalid,
  combinationIndex,
  disabled,
  isShowButton = false,
  buttonLabel,
  handleClickButton,
  autoFocus = false,
  type = 'text',
}) => {
  const isDesktop = useResponsive();
  return (
    <CCol lg={colSize} className={className}>
      {inputLabel && (
        <CFormLabel className='fs-6 fs-md-3'>
          {inputLabel}
        </CFormLabel>
      )}
      {
        isShowButton && (
          <CButton
            onClick={() => handleClickButton()}
            style={styleButtonVars2}
            className='ms-2 mb-2'
            size={isDesktop ? 'md' : 'sm'}
          >
              {buttonLabel}
          </CButton>
        )
      }
      <CFormInput
        id={id}
        name={name}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={(e) => handleTextInput(e, combinationIndex)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid}
        autoFocus={autoFocus}
        disabled={disabled}
        className='fs-6 fs-md-3'
      />
    </CCol>
  )
}

export default FormTextInput
